import { useRef, useState } from 'react';
import generateFilterServicePackages from '../../../helpers/utils/generateFilterServicePackages';
import emojiRegex from 'emoji-regex';
import Accordion from '../../atoms/Accordion';
import DropUpArrow from '../../atoms/Icons/DropUpArrow';
import DropDownArrow from '../../atoms/Icons/DropDownArrow';
import SearchServices from '../FilterMenu/Search';
import { useRouter } from '../../../hooks/useCustomRouter';
import { IServicesPackages } from '../ServicesListSection/interface';
import { IFilterOptions } from '../../../interface/accessories.interface';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionPackageServiceList from '../../../hooks/emarsys/package-service/useImpressionPackageServiceList';
import eventClickPackageServiceList from '../../../helpers/emarsys/package-service/eventClickPackageServiceList';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import eventClickCouponServiceList from '../../../helpers/emarsys/coupon-service/eventClickCouponServiceList';
import {
  BUTTON_NAME_SERVICE_COUPON,
  SECTION_NAME_SERVICE_COUPON,
} from '../../../constants/emarsys/service-coupon';
import {
  BUTTON_NAME_SERVICE_PACKAGE,
  SECTION_NAME_SERVICE_PACKAGE,
} from '../../../constants/emarsys/service-package';
import useImpressionCouponServiceList from '../../../hooks/emarsys/coupon-service/useImpressionCouponServiceList';

interface FilterServicesProps {
  sortsList?: Array<{ value?: string; name: string; selected?: boolean; code?: string }>;
  carModel?: IFilterOptions;
  specialOffer?: IFilterOptions;
  freeTextSearch?: string;
  typeID?: string;
  setTriggerGTM?: (value: boolean) => void;
  setTriggerFilter?: (value: boolean) => void;
  servicePackagesForFilter?: IServicesPackages[];
  impressionData?: {
    title: string;
    carModels: string[];
    breadcrumbItems: IBreadcrumbs[];
    customerNo?: string;
    carCategory?: string;
    filterValue?: {
      search: string;
      special_offer: string;
      car_model: string;
      order_by: string;
    };
    sectionName: string;
  };
  feature?: string;
}

const FilterServices = ({
  sortsList,
  carModel,
  specialOffer,
  freeTextSearch,
  typeID,
  setTriggerGTM,
  setTriggerFilter,
  servicePackagesForFilter,
  impressionData,
  feature,
}: FilterServicesProps) => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);
  const impressionRef = useRef(null);

  const symbolRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

  const router = useRouter();

  const [recs, setRecs] = useState<IServicesPackages[]>([]);

  const handleOptionChange = (e) => {
    const newValue = e.target.value;
    if (feature === 'PACKAGE_SERVICE_LIST') {
      eventClickPackageServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        impressionData?.customerNo,
        SECTION_NAME_SERVICE_PACKAGE.FILTER,
        BUTTON_NAME_SERVICE_PACKAGE.URUTKAN,
        impressionData?.carModels,
        {
          ...impressionData.filterValue,
          order_by: sortsList?.find((item) => item.code === newValue)?.name,
        }
      );
    }
    if (feature === 'COUPON_SERVICE_LIST') {
      eventClickCouponServiceList(
        dispatch,
        impressionData.carCategory,
        impressionData?.title,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        SECTION_NAME_SERVICE_COUPON.FILTER,
        BUTTON_NAME_SERVICE_COUPON.URUTKAN,
        {
          ...impressionData.filterValue,
          order_by: sortsList?.find((item) => item.code === newValue)?.name,
        }
      );
    }
    router.push({
      query: { ...router.query, sort: newValue },
    });
  };

  const filters = generateFilterServicePackages(
    carModel,
    specialOffer,
    typeID,
    setTriggerFilter,
    impressionData,
    feature
  );

  let searchDebouncerTimer;

  const handleClickSearch = (name: string) => {
    // Emarsys
    if (typeID === 'package') {
      eventClickPackageServiceList(
        dispatch,
        impressionData?.carCategory,
        impressionData?.title,
        impressionData?.breadcrumbItems,
        impressionData?.customerNo,
        SECTION_NAME_SERVICE_PACKAGE.FILTER,
        BUTTON_NAME_SERVICE_PACKAGE.SEARCH,
        impressionData?.carModels,
        { ...impressionData.filterValue, search: name }
      );
    }

    if (feature === 'COUPON_SERVICE_LIST') {
      eventClickCouponServiceList(
        dispatch,
        impressionData.carCategory,
        impressionData?.title,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        SECTION_NAME_SERVICE_COUPON.FILTER,
        BUTTON_NAME_SERVICE_COUPON.SEARCH,
        { ...impressionData.filterValue, search: name }
      );
    }

    const isSlugPath = router.pathname.includes('/[category]');
    const isValidSeach = !emojiRegex().test(name) && !symbolRegex.test(name);
    if (isSlugPath) {
      if (name) {
        router.push({
          pathname: router.pathname,
          query: {
            ...router.query,
            q: isValidSeach ? name : 'invalid search',
          },
        });
      } else {
        const updatedquery = router.query;
        delete updatedquery.q;
        router.push({
          pathname: router.pathname,
          query: {
            ...updatedquery,
          },
        });
      }
    } else {
      if (name) {
        router.push({
          query: {
            q: isValidSeach ? name : 'invalid search',
          },
        });
      } else {
        const updatedquery = router.query;
        delete updatedquery.q;
        router.push({
          query: {
            ...updatedquery,
          },
        });
      }
    }

    setRecs([]);
  };

  const filterRecs = (serviceName: string) => {
    const category = router.query?.category;
    if (category) {
      setRecs(
        servicePackagesForFilter.filter(
          (item) =>
            item?.name?.toLowerCase()?.includes(serviceName.toLowerCase()) &&
            item?.bodyType?.includes(category?.toString()?.toUpperCase())
        )?.length > 0
          ? servicePackagesForFilter.filter(
              (item) =>
                item?.name?.toLowerCase()?.includes(serviceName.toLowerCase()) &&
                item?.bodyType?.includes(category?.toString()?.toUpperCase())
            )
          : [{ code: 'code-placeholder' }]
      );
    } else {
      setRecs(
        servicePackagesForFilter.filter((item) =>
          item?.name?.toLowerCase()?.includes(serviceName.toLowerCase())
        )?.length > 0
          ? servicePackagesForFilter.filter((item) =>
              item?.name?.toLowerCase()?.includes(serviceName.toLowerCase())
            )
          : [{ code: 'code-placeholder' }]
      );
    }
  };

  const handleSearch = (e) => {
    const newValue = e;
    clearTimeout(searchDebouncerTimer);
    searchDebouncerTimer = setTimeout(async () => {
      if (newValue.length >= 2) {
        // search for recomendations here
        filterRecs(newValue);
      } else {
        // const query = router.query;
        // delete query?.p;
        // router.push({ ...query });
        setRecs([]);
      }
    }, 500);
  };

  // Emarsys Impression
  if (typeID === 'package') {
    useImpressionPackageServiceList(
      impressionRef,
      impressionData?.title,
      impressionData?.breadcrumbItems,
      'filter',
      impressionData?.carModels
    );
  }

  if (feature === 'COUPON_SERVICE_LIST') {
    useImpressionCouponServiceList(
      impressionRef,
      impressionData?.title,
      impressionData?.breadcrumbItems,
      'filter',
      impressionData?.carModels
    );
  }

  return (
    <section className="w-full lg:max-w-[292px]" ref={impressionRef}>
      <div className="hidden lg:sticky lg:top-[173px] lg:z-20 lg:pr-4 lg:overflow-x-auto lg:no-scrollbar lg:block">
        <p className="text-xl font-bold mb-3">Filter</p>

        <div className="lg:mb-3">
          <SearchServices
            handleClickSearch={handleClickSearch}
            recs={recs}
            filterRecs={filterRecs}
            className="px-4"
            placeholderText={
              typeID === 'coupon'
                ? 'Cari kupon servis'
                : typeID.includes('accessories')
                  ? 'Cari Aksesoris & Spareparts'
                  : 'Cari paket servis'
            }
            iconColor="#393536"
            onValueChange={handleSearch}
            freeTextSearch={freeTextSearch}
          />
        </div>

        <div className="mb-6">
          {filters.map((filter, index) => (
            <div key={index} className="mb-3">
              <Accordion
                key={index}
                classNameDetails={'py-4 px-0'}
                classNameSummary={
                  '-my-[18px] py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base'
                }
                classTitleWrapper={
                  'w-full flex justify-between items-center px-4 lg:px-0 font-semibold text-[16px] text-[#231F20]'
                }
                classNameChildrenWrapper={
                  'text-start text-sm font-normal text-reliableBlack leading-relaxed lg:text-base lg:leading-relaxed px-4 lg:px-0'
                }
                dataIndex={index}
                title={filter.title === 'Model Kendaraan' ? 'Model Mobil' : filter.title}
                activeIcon={<DropUpArrow />}
                inactiveIcon={<DropDownArrow />}
              >
                {filter.content}
              </Accordion>
            </div>
          ))}
        </div>

        <p className="text-xl font-bold mb-3">Urutkan</p>
        <ul className="flex flex-col gap-3 text-base text-reliableBlack">
          {sortsList?.map((option) => (
            <li key={option.value}>
              <div className="flex wrapper-radio items-center py-2 ">
                <input
                  id={`radio-${option.code}`}
                  type="radio"
                  value={option.code}
                  name="radio-options"
                  className="radio-input w-4 h-4 text-[#231F20] bg-gray-100  focus:ring-reliableBlack60"
                  checked={option.selected}
                  onChange={handleOptionChange}
                  onClick={() => {
                    setTriggerGTM(true);
                  }}
                />
                <label
                  htmlFor={`radio-${option.code}`}
                  className="ml-2 text-base font-normal text-reliableBlack"
                >
                  {option.name}
                </label>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FilterServices;
